import { graphql } from "@/api/graphql/types/gql";

export const cancelSupportAgentInviteMutation = graphql(`
  mutation CancelSupportAgentInvite(
    $request: AccountsMsCancelSupportUserInviteRequest
  ) {
    AccountsMsCancelSupportUserInvite(request: $request)
  }
`);
